import React from 'react';
import { useSelector } from 'react-redux';
import { ContactSheet } from '../../Modals/CustomModal';
import { getClaimEscalationLevels } from '../../../utils/escalationMatrix';

interface SupportDrawerProps {
  visible: boolean;
  onClose: () => void;
  title: string;
}

// Thin wrapper over the shared mobile ContactSheet so employer and member "Need Help" look identical.
export const SupportDrawer: React.FC<SupportDrawerProps> = ({ visible, onClose, title }) => {
  const relationship_managers = useSelector((state: any) => state.auth?.relationship_managers);
  const activeMode = useSelector((state: any) => state.auth?.activeMode);

  return (
    <ContactSheet
      visible={visible}
      onClose={onClose}
      title={title}
      data={{
        ...(activeMode === 'employer' && relationship_managers?.policy_manager?.full_name && {
          relationship_manager: relationship_managers.policy_manager,
        }),
        claim_managers: getClaimEscalationLevels(relationship_managers),
        claim_manager: relationship_managers?.claim_manager,
      }}
    />
  );
};
